// TODO: to be generated by api specs
export type Endpoint = {
    endpoint: string
}
